import View from "../../../../../../../vendor/framework/view";
import Table from "../../../../layout/table";
import UserAttrService from "../../../../../services/running/userAttr";

export default class UserAttrListLayout extends View
{
    service() {
        return UserAttrService;
    }

    componentDidMount() {
        /* global layer */
    }

    render() {
        return (
            <Table
                props={this.props}
                service={UserAttrService}
                stateInit={{
                    orderBy:['id', 'desc']
                }}
                searchInit={{
                    name:{name:'名称', enter: true},
                    status:{name:'状态', value:'',type: 'select', data: [{key:'',name:'--全部--'},{key:1,name:'开启'}, {key:0, name:'禁用'}], option:['key', 'name']},
                }}
                fieldsInit={{
                    id:{name:'ID', checkbox: true, sort:{asc:'asc', desc:'desc'}},
                    name:'名称',
                    sort:{name:'排序', type: 'input', change:this.server.changeSort.bind(this.server), sort:{asc:'asc', desc:'desc'}},
                    status:{name:'状态', type:'switch', checked:1, text:'开启|禁用', change:this.server.changeState.bind(this.server)},
                    createdAt:'添加时间'
                }}
                oprationInit={{
                    edit:{name:'编辑', icon: ['edit'], click: this.edit.bind(this)},
                    delete:{name: '删除', icon:['delete', 'danger'], click:this.delete.bind(this)}
                }}
                btnInit={{
                    add:{name:'添加', click: this.add.bind(this)}
                }}
            />
        );
    }

    add(table) {
        this.layOpen({
            title:'添加',
            content:'/admin/running/userAttr/add',
            form:true,
            area:['600px', '90%'],
            yes: (field, index) => {
                table.server.save(field, () => {
                    layer.msg('添加成功!');
                    layer.close(index);
                    table.loadData();
                }, (msg) => {
                    layer.msg(msg);
                })
            }
        })
    }

    edit(model, table) {
        this.layOpen({
            title:'修改 '+model.name,
            content:'/admin/running/userAttr/edit/'+model.id,
            form:true,
            area:['600px', '90%'],
            yes: (field, index) => {
                field.id = model.id;
                table.server.save(field, () => {
                    layer.msg('修改成功!');
                    layer.close(index);
                    table.loadData();
                }, (msg) => {
                    layer.msg(msg);
                })
            }
        })
    }

    delete(model, table) {
        layer.confirm(`您真的要删除 ${model.name} 吗?`, () => {
            table.server.delete(model, () => {
                layer.msg('删除成功!');
                table.pageReload();
            }, (msg) => {
                layer.msg(msg);
            })
        })
    }
}
